/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
	| T
	| {
			[P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
	  };
import type * as Types from '../../../../../gql/types-mutations';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type UpdateCognitoUserPreferencesMutationVariables = Exact<{
	cognitoUserPreferences: Types.CognitoUserPreferencesInput;
}>;

export type UpdateCognitoUserPreferencesMutation = {
	updateCognitoUserPreferences: {
		id: string;
		newsletter_opt_in: boolean | null;
	} | null;
};

export const UpdateCognitoUserPreferencesDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'mutation',
			name: { kind: 'Name', value: 'updateCognitoUserPreferences' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: {
						kind: 'Variable',
						name: { kind: 'Name', value: 'cognitoUserPreferences' },
					},
					type: {
						kind: 'NonNullType',
						type: {
							kind: 'NamedType',
							name: { kind: 'Name', value: 'CognitoUserPreferencesInput' },
						},
					},
				},
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'updateCognitoUserPreferences' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'cognitoUserPreferences' },
								value: {
									kind: 'Variable',
									name: { kind: 'Name', value: 'cognitoUserPreferences' },
								},
							},
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'newsletter_opt_in' },
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	UpdateCognitoUserPreferencesMutation,
	UpdateCognitoUserPreferencesMutationVariables
>;
